export class UserNotification {
    constructor(public userNotificationType?:string,
                public userNotificationDescription?:string,
                public selected?:boolean){}
}